import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, AbstractControl, ValidationErrors } from '@angular/forms'; 
import { CustomSnackbarService } from '../../custom-notification/custom-notification.component'; 
import { LocalBusinessManagerService } from 'src/app/service/local-business-manager.service';

@Component({
  selector: 'app-edit-local-business-product',
  templateUrl: './edit-local-business-product.component.html',
  styleUrls: ['./edit-local-business-product.component.css']
})
export class EditLocalBusinessProductComponent implements OnInit {
  form!: FormGroup;
  
  constructor(private fb: FormBuilder, private productListingService: LocalBusinessManagerService, private customSnackbarService: CustomSnackbarService) { }
  
  @Input() formTitle: string = '';
  @Output() resetListing = new EventEmitter<void>();
  @Input() selectedProductId: number = 0;
  @Output() close = new EventEmitter<void>();
  @Input() viewMode:boolean = false;
  availableBranchesList: any = {
    loading: false,
    response: null,
    error: ''
  };
  deletedVarient:number[] = [];
  productDetails: any = {
    loading: false,
    response: null,
    error: ''
  };
  categoryList: any = {
    loading: false,
    response: null,
    error: ''
  };
  subCategoryList: any = {
    loading: false,
    response: null,
    error: ''
  };
  subCategoryVarientList: any = {
    loading: false,
    response: null,
    error: ''
  };
  weightUnitList: any = {
    loading: false,
    response: null,
    error: ''
  };
  delDistanceList: any = {
    loading: false,
    response: null,
    error: ''
  };
  prodTypeList: any = {
    loading: false,
    response: null,
    error: ''
  };
  packingTypeList: any = {
    loading: false,
    response: null,
    error: ''
  };
  stockStatusList: any = {
    loading: false,
    response: null,
    error: ''
  };
  statusList: any = {
    loading: false,
    response: null,
    error: ''
  };
  selectedAvilableBranches: any[] = [];
  allowedFileSizeToUpload: number = 2; //size in MB
  uploadingFile: boolean = false;
  submitLoading: boolean = false;
  uploadingMediaIndex:number|null=null;
  uploadingVarientMediaIndex:number|null=null;
  ngOnInit() {
    this.form = this.fb.group({
      id: [null],
      productId: [null],
      businessId: [null],
      productName: ['', [Validators.required, Validators.maxLength(64)]],
      categoryId: ['', Validators.required],
      subCategoryId: ['', Validators.required],
      description: ['', Validators.required],
      availableBranches: ['', Validators.required],
      weight: [null],
      weightUnitId: [''],
      delDistanceId: ['', Validators.required],
      productTypeId: ['', Validators.required],
      packingTypeId: [''],
      mediaList: this.fb.array([this.fb.control("", Validators.required), this.fb.control(""), this.fb.control(""), this.fb.control("")]),
      variantList: this.fb.array([this.createVariantGroup()])
    });

    this.getProductCategories()
    this.getProductWeightUnits()
    this.getProductDeliveryDistance()
    this.getProductTypes()
    this.getPackagingTypes()
    this.getStockStatus()
    this.getProductStatus()
    this.getAllAvailableBranches(this.selectedProductId)
    this.form.get('categoryId')?.valueChanges.subscribe(newCategoryValue => {
      // Handle changes here
      this.form.get('subCategoryId')?.setValue('')
      this.subCategoryVarientList = {
        loading: false,
        response: null,
        error: ''
      }
      this.resetVariantList();
      this.getSubCategories(newCategoryValue)
    });

    this.form.get('subCategoryId')?.valueChanges.subscribe(value => {
      // Handle changes here
      this.resetVariantList();
      this.getSubCategoryVarients(value)
    });
    this.showProductDetails(this.selectedProductId)
    // console.log(this.selectedProductId,'selectedProductId')
  }

  showProductDetails(id: number) {
    this.productDetails = {
      ...this.productDetails,
      loading: true,
      error: ''
    }
    this.productListingService.getProductById(id).then((res: any) => {
      const product = res.data.data;
      this.productDetails = {
        ...this.productDetails,
        loading: false,
        response: res.data.data,
      }
      this.form.get('id')?.setValue(product.id || '');
      this.form.get('productId')?.setValue(product.id || '');
      this.form.get('businessId')?.setValue(product.businessId || '');
      this.form.get('productName')?.setValue(product.productName || '');
      this.form.get('categoryId')?.setValue(product.categoryId || '');
      this.form.get('subCategoryId')?.setValue(product.subCategoryId || '');
      this.form.get('description')?.setValue(product.description || '');
      this.form.get('availableBranches')?.setValue(product.availableBranches.length ? product.availableBranches : '');
      this.form.get('weight')?.setValue(Number(product.weight) || '');
      this.form.get('weightUnitId')?.setValue(product?.weightUnitId || '');
      this.form.get('delDistanceId')?.setValue(product.delDistanceId || '');
      this.form.get('productTypeId')?.setValue(product.productTypeId || '');
      this.form.get('packingTypeId')?.setValue(product.packingTypeId || '');
      this.selectedAvilableBranches = product.availableBranches.map((l:any)=>({id:l.id}));
      if (product.mediaList?.length) {
        product.mediaList.forEach((l: { id: number, src: string }, i: number) => {
          (this.form.get('mediaList') as FormArray).at(i).patchValue(l);
        })
      }

    }).catch((err: any) => {
      console.log(err, 'ffffffff')
      this.productDetails = {
        ...this.productDetails,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }
  getAllAvailableBranches(productId:number) {
    this.availableBranchesList = {
      ...this.availableBranchesList,
      loading: true,
      error: ''
    }
    this.productListingService.getAvailableBranch(productId).then((res: any) => { 
      this.availableBranchesList = {
        ...this.availableBranchesList,
        loading: false,
        response: res.data.records,
      }
    }).catch((err: any) => {
      this.availableBranchesList = {
        ...this.availableBranchesList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }
  countChars(string:String){
    return string.length
  }
  selectedAvilableBranchesToShow(data:any[]){
    return data.map((l:any)=>l.name).join(',')
  }
  comparer(o1: any, o2: any): boolean {
    // if possible compare by object's name, and not by reference.
    return o1 && o2 ? o1.label === o2.label : o2 === o2;
  }
  resetVariantList() {
    const variantList = this.form.get('variantList') as FormArray;
    while (variantList.length !== 0) {
      variantList.removeAt(0);
    }

    if (this.productDetails?.response?.variantList?.length) {
      this.populateVariantList(this.productDetails.response.variantList)
    } else {
      variantList.push(this.createVariantGroup());

    }
  }
  // Convenience getters for easy access to form arrays and controls
  get mediaList(): FormArray {
    return this.form.get('mediaList') as FormArray;
  }

  get variantList(): FormArray {
    return this.form.get('variantList') as FormArray;
  }

  get variantControls(): FormGroup[] {
    return (this.form.get('variantList') as FormArray).controls as FormGroup[];
  }
  populateVariantList(variantListData: any[]) {
    const control = this.form.get('variantList') as FormArray;

    variantListData.forEach(variantData => {
      const variantGroup = this.createVariantGroup(variantData);
      control.push(variantGroup);

      // Populate mediaList for each variant
      const mediaList = variantGroup.get('mediaList') as FormArray;
      if (variantData.mediaList.length) {
        variantData.mediaList.forEach((media: { id: number, src: string }) => {
          mediaList.push(this.fb.control(media, Validators.required));
        });
      } else {
        mediaList.push(this.fb.control({ src: '' }));
      }
    });
  }
  createVariantGroup(variantData?: any): FormGroup {
    const group = this.fb.group({
      id: [variantData?.id || null],
      sku: [variantData?.sku || ''],
      price: [variantData?.price ? Number(variantData?.price) : '', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/), Validators.min(1)]],
      discountedPrice: [variantData?.discountedPrice ? Number(variantData?.discountedPrice) : '', [Validators.pattern(/^\d+(\.\d{1,2})?$/), this.discPriceCantMoreThanPrice]],
      quantity: [variantData?.quantity ? Number(variantData?.quantity) : '', [Validators.pattern(/^\d+$/)]],
      statusId: [variantData?.statusId || '', Validators.required],
      stockStatusId: [variantData?.stockStatusId || '', Validators.required],
      variantId1: [this.subCategoryVarientList.response?.[0]?.id || null],
      variantId2: [this.subCategoryVarientList.response?.[1]?.id || null],
      variantId3: [this.subCategoryVarientList.response?.[2]?.id || null],
      variantOption1: [variantData?.variantOption1 || null],
      variantOption2: [variantData?.variantOption2 || null],
      variantOption3: [variantData?.variantOption3 || null],
      mediaList: this.fb.array([])
    });

    // Subscribe to the 'price' control valueChanges event
    const priceControl = group.get('price');
    if (priceControl) {
      priceControl.valueChanges.subscribe(() => {
        const discountedPriceControl = group.get('discountedPrice');
        if (discountedPriceControl) {
          // Clear the value of discountedPrice when price changes
          discountedPriceControl.setValue(discountedPriceControl.value);
          discountedPriceControl.updateValueAndValidity();
        }
      });
    }

    return group;
  }

  discPriceCantMoreThanPrice(control: any) {
    const value = control.value;
    // Check if the value is greater than 0
    if (value && Number(control?._parent?.value?.price) <= Number(value)) {
      return { moreThanPrice: true };
    }
    return null;
  }
  addMedia() {
    this.mediaList.push(this.fb.control({ src: "" }, Validators.required));
  }


  // Accessor for the mediaList FormArray
  get mediaListt() {
    return (this.form.get('mediaList') as FormArray).controls;
  }
  addMediaAtIndex(mediaIndex: number, updatedObject: any) {
    if (mediaIndex >= 0 && mediaIndex <= this.mediaListt.length) {
      (this.form.get('mediaList') as FormArray).at(mediaIndex).patchValue(updatedObject);
    }
  }

  removeMedia(mediaIndex: number) {
    // this.mediaList.removeAt(index);
    if (mediaIndex >= 0 && mediaIndex <= this.mediaListt.length) {
      (this.form.get('mediaList') as FormArray).at(mediaIndex).patchValue("");
    }
  }

  resetFileInput(event: any) {
    const fileInput = event.nativeElement;
    const newFileInput = document.createElement('input');
    newFileInput.type = 'file';
    newFileInput.id = fileInput.id;

    // Copy any other attributes you may need

    fileInput.parentNode.replaceChild(newFileInput, fileInput);
    event.nativeElement = newFileInput;
  }

  addVariant() {
    const group = this.fb.group({
      id: [null],
      sku: [''],
      price: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/), Validators.min(1)]],
      discountedPrice: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/), this.discPriceCantMoreThanPrice]],
      quantity: ['', [Validators.pattern(/^\d+$/)]],
      statusId: ['', Validators.required],
      stockStatusId: ['', Validators.required],
      variantId1: [this.subCategoryVarientList.response?.[0]?.id || null],
      variantId2: [this.subCategoryVarientList.response?.[1]?.id || null],
      variantId3: [this.subCategoryVarientList.response?.[2]?.id || null],
      variantOption1: [null],
      variantOption2: [null],
      variantOption3: [null],
      mediaList: this.fb.array([{ src: '' }])
    })
    // Subscribe to the 'price' control valueChanges event
    const priceControl = group.get('price');
    if (priceControl) {
      priceControl.valueChanges.subscribe(() => {
        const discountedPriceControl = group.get('discountedPrice');
        if (discountedPriceControl) {
          // Clear the value of discountedPrice when price changes
          discountedPriceControl.setValue(discountedPriceControl.value);
          discountedPriceControl.updateValueAndValidity();
        }
      });
    }

    this.variantList.push(group);
  }

  removeVariant(index: number, varientId?:number) {
    this.variantList.removeAt(index);
    if(varientId){
      this.deletedVarient.push(varientId)
    }
  }

  addVariantMedia(variantIndex: number, media: { src: string }) {
    const mediaList = (this.variantControls[variantIndex].get('mediaList') as FormArray);
    while (mediaList.length !== 0) {
      mediaList.removeAt(0);
    }
    mediaList.push(this.fb.control(media, Validators.required));
  }

  removeVariantMedia(variantIndex: number, mediaIndex: number) {
    const mediaList = (this.variantControls[variantIndex].get('mediaList') as FormArray);
    mediaList.removeAt(mediaIndex);
    mediaList.push(this.fb.control({ src: "" },));
  }

  handleReset() {
    // this.form.reset()
    // this.form.get('statusId')?.setValue(1)
    this.deletedVarient = [];
    // this.showProductDetails(this.selectedProductId)
    this.close.emit()
  }
  getProductCategories() {
    this.categoryList = {
      ...this.categoryList,
      loading: true,
      error: ''
    }
    this.productListingService.getProductCategories().then((res: any) => {
      this.categoryList = {
        ...this.categoryList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.categoryList = {
        ...this.categoryList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }


  getProductWeightUnits() {
    this.weightUnitList = {
      ...this.weightUnitList,
      loading: true,
      error: ''
    }
    this.productListingService.getWeightUnits().then((res: any) => {
      this.weightUnitList = {
        ...this.weightUnitList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.weightUnitList = {
        ...this.weightUnitList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }

  getProductDeliveryDistance() {
    this.delDistanceList = {
      ...this.delDistanceList,
      loading: true,
      error: ''
    }
    this.productListingService.getDelDistance().then((res: any) => {
      this.delDistanceList = {
        ...this.delDistanceList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.delDistanceList = {
        ...this.delDistanceList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }

  getProductTypes() {
    this.prodTypeList = {
      ...this.prodTypeList,
      loading: true,
      error: ''
    }
    this.productListingService.getProductTypes().then((res: any) => {
      this.prodTypeList = {
        ...this.prodTypeList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.prodTypeList = {
        ...this.prodTypeList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }

  getPackagingTypes() {
    this.packingTypeList = {
      ...this.packingTypeList,
      loading: true,
      error: ''
    }
    this.productListingService.getPackageType().then((res: any) => {
      this.packingTypeList = {
        ...this.packingTypeList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.packingTypeList = {
        ...this.packingTypeList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }

  getStockStatus() {
    this.stockStatusList = {
      ...this.stockStatusList,
      loading: true,
      error: ''
    }
    this.productListingService.getStockStatus().then((res: any) => {
      this.stockStatusList = {
        ...this.stockStatusList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.stockStatusList = {
        ...this.stockStatusList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }

  getProductStatus() {
    this.statusList = {
      ...this.statusList,
      loading: true,
      error: ''
    }
    this.productListingService.getProductStatus().then((res: any) => {
      this.statusList = {
        ...this.statusList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.statusList = {
        ...this.statusList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }

  getSubCategories(catId: string) {
    if (!catId) {
      return
    }
    this.subCategoryList = {
      ...this.subCategoryList,
      response: null,
      loading: true,
      error: ''
    }
    this.productListingService.getProductSubCategories(catId).then((res: any) => {
      this.subCategoryList = {
        ...this.subCategoryList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.subCategoryList = {
        ...this.subCategoryList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }

  getSubCategoryVarients(subCatId: string) {
    if (!subCatId) {
      return
    }
    this.subCategoryVarientList = {
      ...this.subCategoryVarientList,
      response: null,
      loading: true,
      error: ''
    }
    this.productListingService.getSubCategoryVarients(subCatId).then((res: any) => {
      const variants = res.data.data;
      let varientsOptions = variants.map((l: any) => {
        return this.productListingService.getVarientOptions(l.id).then((vor: any) => ({
          ...l,
          options: vor.data.data
        })).catch(() => ([]))
      })
      Promise.all(varientsOptions).then(vo => {
        this.subCategoryVarientList = {
          ...this.subCategoryVarientList,
          loading: false,
          response: vo,
        }
        this.resetVariantList()
      })
    }).catch((err: any) => {
      this.subCategoryVarientList = {
        ...this.subCategoryVarientList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }
  allowOnlyNumeric(event: KeyboardEvent) {
    // Allow backspace
    if (event.key === 'Backspace') {
      return true;
    }

    // Allow only numeric digits
    const isNumeric = /^\d$/.test(event.key);

    if (!isNumeric) {
      event.preventDefault();
      return false;
    }

    return true; // This line is necessary for TypeScript to be satisfied
  }


  uploadFileWhileEdit(value: any, type: string, index: number) {
    const selectedFile = value.files[0];
    const maxSizeInBytes = this.allowedFileSizeToUpload * 1024 * 1024; // 2MB (adjust to your maximum size)
    if (selectedFile.type === "image/png" || selectedFile.type === "image/jpg" || selectedFile.type === "image/jpeg") {

      if (selectedFile && selectedFile.size > maxSizeInBytes) {
        this.customSnackbarService.openCustomSnackbar(`File size must be less than ${this.allowedFileSizeToUpload} MB`, 30000, true);
        return
      }
      if(type === "varient"){
        this.uploadingVarientMediaIndex = index;
       }
       if(type === "media"){
         this.uploadingMediaIndex = index;
       }
      this.uploadingFile = true;
      let formData: FormData = new FormData();
      formData.append('files', value.files[0]);
      formData.append('type', 'ProductMedia')
      this.productListingService.uploadFile(formData).then((res: any) => {
        if (res.data.status === "SUCCESS") {
          if (type === 'varient') {
            this.addVariantMedia(index, { src: res.data.data.documentUri })
          }
          if (type === "media") {
            console.log(res, 'ssssss')
            this.addMediaAtIndex(index, { src: res.data.data.documentUri })
          }
          this.uploadingFile = false;
          this.uploadingVarientMediaIndex = null;
          this.uploadingMediaIndex = null;
        }
      }).catch((error: any) => {
        this.uploadingVarientMediaIndex = null;
        this.uploadingMediaIndex = null;
        this.uploadingFile = false;
        this.customSnackbarService.openCustomSnackbar('Something is broken', 3000, true);
      })
    } else {
      this.customSnackbarService.openCustomSnackbar('Only accept .png, .jpg, .jpeg', 30000, true);

    }
  }

  onSubmit() {
    if(this.submitLoading || this.uploadingFile){
      return
    }
    if (this.form.valid) {
      // Handle form submission logic here
      this.submitLoading = true;
      if(this.deletedVarient?.length){
        this.deletedVarient.forEach((id:number)=>{
          this.productListingService.deleteVarient(id)
        })
      }
      this.form.value.mediaList = this.form.value.mediaList.filter((l:any)=>l)
      this.form.value.variantList = this.form.value.variantList.map((l:any)=>({...l, sku: l.sku ? l.sku : null}))
      this.productListingService.saveProduct(this.form.value).then((res: any) => {
        if (res.data.status === "SUCCESS") {
          this.resetListing.emit()
          this.submitLoading = false;
          if(this.form.value.productId){
            this.customSnackbarService.openCustomSnackbar('The product has been updated successfully.', 30000);
          }else{
            this.customSnackbarService.openCustomSnackbar('The product has been added successfully.', 30000);
          }
        }
      }).catch((error: any) => {
        console.log(error, 'ddd')
        this.submitLoading = false;
        this.customSnackbarService.openCustomSnackbar('Something is broken', 3000, true);
      })
    } else {
      console.log(this.form);
      // Mark all controls as touched to display validation messages
      this.form.markAllAsTouched();
    }
  }
}
